// extracted by mini-css-extract-plugin
module.exports = {"description":"BrandInfoDescription_description__Dmjra","descriptionExpanded":"BrandInfoDescription_descriptionExpanded__qeFX3","toggle":"BrandInfoDescription_toggle__gsNU_"};